export default "__VITE_ASSET__QL$hLAvd__"